import React, { useEffect, useState } from "react";
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PROD // https://demenagementsamyyhaul.ca/api
    : process.env.REACT_APP_API_URL_DEV; // http://158.69.205.231:3000


const Footer = () => {
  const [company, setCompany] = useState(null);

  // Récupération depuis backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/company-config/latest`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erreur HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("Company data (footer):", data);
        setCompany(data);
      })
      .catch((err) => {
        console.error(
          "Erreur lors de la récupération du company-config :",
          err
        );
      });
  }, []);

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-10 text-center">
      <div className="max-w-7xl mx-auto px-6">
        {/* Grille centrée */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 justify-items-center">
          {/* Logo + description */}
          <div className="flex flex-col items-center space-y-4">
            <a href="#" className="flex flex-col items-center space-y-3">
              {company?.logo && (
                <img
                  src={
                    company.logo?.startsWith("http")
                      ? company.logo
                      : `${API_BASE_URL}${company.logo || "/default-logo.png"}`
                  }
                  alt={`Logo de ${company?.name || "l'entreprise"}`}
                  className="w-12 h-12 object-contain rounded-lg border-2 border-white p-1 bg-white"
                />
              )}
              <span className="text-2xl font-bold">
                {company?.name || "Chargement..."}
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              {company?.description || "Votre partenaire de confiance"}
            </p>
            <div className="flex space-x-4 justify-center">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition transform hover:scale-110"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition transform hover:scale-110"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition transform hover:scale-110"
              >
                <i className="fab fa-twitter"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-white transition block">
                  Déménagement Résidentiel
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition block">
                  Déménagement Commercial
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition block">
                  Transport Spécialisé
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition block">
                  Entreposage
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition block">
                  Emballage Professionnel
                </a>
              </li>
            </ul>
          </div>

      {/* Contact avec réseaux sociaux */}
<div className="space-y-6">
  <h4 className="text-lg font-semibold text-white">Contact</h4>
  
  <ul className="space-y-3 text-gray-300">
    <li className="flex items-center space-x-3">
      <div className="flex-shrink-0 w-5 h-5 text-blue-400">
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/>
        </svg>
      </div>
      <span className="text-sm">
        {company?.address || "Adresse en cours de chargement"}
      </span>
    </li>
    
    <li className="flex items-center space-x-3">
      <div className="flex-shrink-0 w-5 h-5 text-green-400">
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
      </div>
      <span className="text-sm">{company?.phone || "Téléphone indisponible"}</span>
    </li>
    
    <li className="flex items-center space-x-3">
      <div className="flex-shrink-0 w-5 h-5 text-red-400">
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      </div>
      <span className="text-sm">{company?.email || "Email indisponible"}</span>
    </li>
  </ul>

  {/* Réseaux sociaux avec icônes modernes */}
  <div className="pt-4 mt-4 border-t border-gray-700">
    <h5 className="text-sm font-semibold mb-4 text-gray-300">Suivez-nous sur les réseaux</h5>
    <div className="flex justify-center space-x-6">
      {/* Facebook */}
      <a
        href="http://facebook.com/p/D%C3%A9m%C3%A9nagement-Samyys-HauL-61578969911809/"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="group flex items-center justify-center w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 transition-all duration-300 transform hover:scale-110"
        aria-label="Visitez notre page Facebook"
        title="Facebook Samyys Haul"
      >
        <svg className="w-5 h-5 text-white group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      </a>

      {/* Instagram */}
      <a
        href="https://www.instagram.com/p/DNS81l3IVS8/"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="group flex items-center justify-center w-10 h-10 rounded-full bg-gray-800 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 transition-all duration-300 transform hover:scale-110"
        aria-label="Visitez notre Instagram"
        title="Instagram Samyys Haul"
      >
        <svg className="w-5 h-5 text-white group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      </a>
    </div>
    
    <p className="text-xs text-gray-500 text-center mt-3">
      Restez connecté avec nos actualités
    </p>
  </div>
</div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-200 text-sm">
          <p>
            &copy; {new Date().getFullYear()} {company?.name || "Samyy's Haul"}.
            Tous droits réservés. |
            <a href="#" className="hover:text-white transition ml-2">
              Mentions légales
            </a>{" "}
            |
            <a href="#" className="hover:text-white transition ml-2">
              Politique de confidentialité
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
